import { rem } from "polished";
export function createSpacing(spacing) {
    const values = Object.assign({ xs: 4, sm: 8, md: 16, lg: 24, xl: 32 }, spacing);
    return function (...args) {
        const spacings = args.filter(x => x !== undefined);
        return spacings.map(key => (key === "auto" ? "auto" : rem(typeof key === "number" ? key : values[key]))).join(" ");
    };
}
export default createSpacing;
//# sourceMappingURL=create-spacing.js.map